import {FieldType} from "../../manager/FieldType";
import {Button} from "./Button";
import {attributeGroups} from "./attributeGroups";
import {toolbox} from "./toolbox";
import {FieldTypeManager} from "../../manager/FieldTypeManager";

export const buttonFieldType: FieldType = {
  name: 'button',
  component: Button,
  attributeGroups: attributeGroups,
  toolbox,
};

FieldTypeManager.register(buttonFieldType.name, buttonFieldType);
